import { jsx as a, jsxs as b } from "react/jsx-runtime";
import { Avatar as v, AvatarImage as x, AvatarFallback as d, AvatarBadge as y } from "../Avatar/Avatar.js";
import { getColorNameByText as k } from "../utils/utils.js";
import { cn as A } from "@deputy-ai/common";
import { mergeProps as h } from "@deputy-ai/common/react";
import { UserIcon as w } from "@heroicons/react/24/outline";
const C = /* @__PURE__ */ a(w, { className: "text-primary-600 p-[10%]" });
function U(o) {
  const {
    src: c,
    fallback: r,
    fallbackBgColor: t,
    fallbackTextColor: s,
    badge: e,
    imageProps: n,
    fallbackProps: m,
    ...i
  } = o, l = typeof r == "string", p = l ? /* @__PURE__ */ a("span", { className: "overflow-hidden p-1 text-nowrap", children: r }) : r ?? C, g = !t && l ? k(r) : void 0, f = h(
    {
      className: A(
        g,
        t && "bg-(--bg-color)",
        s && "text-(--text-color)"
      ),
      style: {
        ...t && { "--bg-color": t },
        ...s && { "--text-color": s }
      },
      children: p
    },
    m
  ), u = F(c) ? S : c;
  return /* @__PURE__ */ b(v, { ...i, children: [
    /* @__PURE__ */ a(x, { src: u, ...n }),
    /* @__PURE__ */ a(d, { ...f }),
    e && /* @__PURE__ */ a(y, { children: e })
  ] });
}
function F(o) {
  return o === N || o === P;
}
const N = "https://www.gravatar.com/avatar/00000", P = "anonymous", S = "https://storage.googleapis.com/deputy-ai-manual-us/shared/account/avatar.svg";
export {
  U as DaAvatar,
  C as DaAvatarDefaultFallback
};
